// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__RRrKa","lightText":"Tag_lightText__Ok5WI"};